import Logoblu from '../logo_blu.png';



export const openMultiCPTUReport = (multiData) => {
  if (!multiData || !multiData.length) return;
  // Creiamo una struttura per tutte le prove
  const combinedProve = multiData.map(prova => {
    const combinedData = prova.prof.map((p, index) => ({
      prof: p,
      qc: prova.parQC[index],
      fs: prova.parfs[index],
      u: prova.paru ? prova.paru[index] : undefined,
      rf: prova.parrf ? prova.parrf[index] : undefined,
      k: prova.park ? prova.park[index] : undefined,
      ocr: prova.parocr ? prova.parocr[index] : undefined,
      dr: prova.pardr ? prova.pardr[index] : undefined,
      res: prova.pares ? prova.pares[index] : undefined,
      g0: prova.parg0 ? prova.parg0[index] : undefined,
      ko: prova.parko ? prova.parko[index] : undefined,
      cu: prova.parcu ? prova.parcu[index] : undefined,
      curem: prova.parcurem ? prova.parcurem[index] : undefined,
      m: prova.parm ? prova.parm[index] : undefined,
      phi: prova.parphi ? prova.parphi[index] : undefined,
      phip: prova.parphip ? prova.parphip[index] : undefined,
      qt: prova.parQt ? prova.parQt[index] : undefined,
      qtn: prova.parQtn ? prova.parQtn[index] : undefined,
      bq: prova.parBq ? prova.parBq[index] : undefined,
      icn: prova.paricn ? prova.paricn[index] : undefined,
      ic: prova.paric ? prova.paric[index] : undefined,
    })).sort((a, b) => b.prof - a.prof);
    return {
      name: prova.name,
      tipo: prova.tipo,
      falda: prova.fad,
      data: combinedData
    };
  });


  const allData = combinedProve.map(prova => {
      const profSorted = prova.data.map(d => d.prof);
      const qcSorted = prova.data.map(d => d.qc);
      const fsSorted = prova.data.map(d => d.fs);
      const uSorted = prova.data.map(d => d.u);
      const rfSorted = prova.data.map(d => d.rf);
      const kSorted = prova.data.map(d => d.k);
      const ocrSorted = prova.data.map(d => d.ocr);
      const drSorted = prova.data.map(d => d.dr);
      const resSorted = prova.data.map(d => d.res);
      const g0Sorted = prova.data.map(d => d.g0);
      const koSorted = prova.data.map(d => d.ko);
      const cuSorted = prova.data.map(d => d.cu);
      const curemSorted = prova.data.map(d => d.curem);
      const mSorted = prova.data.map(d => d.m);
      const phiSorted = prova.data.map(d => d.phi);
      const phipSorted = prova.data.map(d => d.phip);
      const qtSorted = prova.data.map(d => d.qt);
      const qtnSorted = prova.data.map(d => d.qtn);
      const bqSorted = prova.data.map(d => d.bq);
      const icnSorted = prova.data.map(d => d.icn);
      const icSorted = prova.data.map(d => d.ic);

      // AGGIUNGI IL RETURN QUI
      return {
        name: prova.name,
        tipo: prova.tipo,
        falda: prova.falda,
        prof: profSorted,
        qc: qcSorted,
        fs: fsSorted,
        u: uSorted,
        rf: rfSorted,
        k: kSorted,
        ocr: ocrSorted,
        dr: drSorted,
        res: resSorted,
        g0: g0Sorted,
        ko: koSorted,
        cu: cuSorted,
        curem: curemSorted,
        m: mSorted,
        phi: phiSorted,
        phip: phipSorted,
        qt: qtSorted,
        qtn: qtnSorted,
        bq: bqSorted,
        icn: icnSorted,
        ic: icSorted,
      };
    });


  // max/min profondità globale (opzionale)
  const allProf = combinedProve.flatMap(p => p.data.map(d => d.prof));
  const maxProf = Math.max(...allProf);
  const minProf = Math.min(...allProf);

  const autLTVal=allData.choseLito;

  // Data e ora odierna
  const now = new Date();
  const dateStr = now.toLocaleDateString('it-IT');
  const timeStr = now.toLocaleTimeString('it-IT');

  // Apriamo una nuova finestra per il report
  const reportWindow = window.open('', '_blank', 'width=1200,height=750');
  const allDataJson = JSON.stringify(allData);


  reportWindow.document.write(`
    <!DOCTYPE html>
    <html>
      <head>
        <script src="https://cdn.plot.ly/plotly-2.27.1.min.js"></script>
        <style>
          * {
            box-sizing: border-box;
            margin: 0;
            padding: 0;
          }
          body {
            font-family: Arial, sans-serif;
            margin: 0;
            padding: 0;
            background: white;
          }

          /* Pulsanti a destra */
          .controls {
            position: fixed;
            top: 10px;
            right: 10px;
            z-index: 1000;
            display: flex;
            gap: 5px;
            background: rgba(255,255,255,0.9);
            padding: 5px;
            border-radius: 8px;
            box-shadow: 0 2px 10px rgba(0,0,0,0.1);
          }

          .print-btn {
            background: #12455b;
            color: white;
            border: none;
            width: 32px;
            height: 32px;
            border-radius: 5px;
            font-size: 16px;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .print-btn:hover {
            background: #0d3445;
          }

          /* PAGINE - senza salti automatici */
          @page {
            size: A4;
            margin: 1.5cm;
          }

          /* Pagina 1 - Verticale */
          .page1 {
            page: A4;
            min-height: 100vh;
            position: relative;
            padding: 20px;
          }

          /* Pagina 2 - Orizzontale */
          .page2 {
              page: landscape;
              size: A4 landscape;
              position: relative;
              padding: 5px 0px;
              display: flex;
              flex-direction: column;

              width: 100%;
              box-sizing: border-box; /* evita che il padding allarghi il box */
            }

          .content-wrapper {
              display: flex;
              flex-direction: column;
              flex: 1;
            }

          @page landscape {
            size: A4 landscape;
            margin: 1.5cm;
          }

          /* Logo solo prima pagina */
          .logo {
            position: absolute;
            bottom: 20px;
            right: 20px;
            width: 33px;
            height: auto;
            opacity: 0.7;
          }

          .logo img {
            width: 100%;
            height: auto;
            display: block;
          }

          /* Pagina 1 - Stili */
          .header {
            text-align: center;
            margin-bottom: 20px;
          }

          .header h1 {
            font-size: 28px;
            color: #333;
            margin-bottom: 5px;
          }

          .header h2 {
            font-size: 20px;
            color: #666;
            font-weight: normal;
          }

          .delimiter {
            text-align: right;
            font-size: 12px;
            color: #666;
            margin-bottom: 20px;
            border-bottom: 1px solid #ccc;
            padding-bottom: 5px;
          }

          .data-table {
            width: 100%;
            border-collapse: collapse;
          }

          .data-table td {
            padding: 8px 12px;
            border: 1px solid #ddd;
          }

          .data-table td:first-child {
            font-weight: bold;
            background-color: #f5f5f5;
            width: 150px;
          }

          .data-table input {
            width: 100%;
            border: none;
            padding: 5px;
            font-size: 14px;
            background: transparent;
          }

          .data-table .readonly {
            background-color: #f9f9f9;
            color: #666;
            font-style: italic;
            padding: 5px;
          }

          /* Pagina 2 - Stili */
          .title-left {
            text-align: left;
            margin: 0 !important;
            padding-bottom: 10 !important;
          }

          .title-left h2 {
              font-size: 20px;
              color: #333;
              margin: 0 !important;
              padding: 0 !important;
              line-height: 1.5 !important;
            }

          .title-left hr {
              width: 40%;
               margin: 2px 0 2px 0 !important;  /* Spazio minimo */
               padding: 0 !important;
              border: 1px solid #12455b;
            }

          /* Container grafici */
          .charts-container {
              margin: 0 !important;
              padding-bottom: 10 !important;
              height: auto;
              min-height: 0;
              display: flex;
              flex-wrap: wrap;
              gap: 5px;  /* Riduci gap se necessario */
              justify-content: center;  /* centra orizzontalmente */
              align-items: center;
            }

          .chart-item {
            width: calc(50% - 5px);
            height: 350px;
            background: white;
            border: 1px solid #eee;
            border-radius: 4px;
            padding: 5px;
          }

          .chart-item .plot-container {
            width: 100%;
            height: 100%;
          }

          .didascalia {
              margin: 0 !important;
              padding: 0 !important;
              line-height: 1 !important;
              font-size: 11px;
              text-align: center; /* centra il testo */
           }

          .page-number {
              font-size: 8px;
              color: #666;
            }

          @media print {
            .controls {
              display: none;
            }
            body {
              margin: 0;
              padding: 0;
            }
            .page1, .page2 {
              box-shadow: none;
              padding: 0.5cm;
            }
            .chart-item {
              border: none;
              height: 380px;
            }
          }

          /* Titolo principale leggermente più piccolo */
            .h1bis {
              font-size: 18px; /* ridotto rispetto a h1 normale */
              margin-bottom: 0.3em;
              font-weight: bold;
            }

            /* Tabella con font più piccolo */
            .data-table.small-table {
              font-size: 12px;
              border-collapse: collapse;
              width: 100%;
            }

            /* Bordo e padding generale */
            .data-table.small-table th,
            .data-table.small-table td {
              padding: 6px 8px;
              border: 1px solid #ccc;
            }

            /* Riga intestazione grigia solo per i titoli */
            .data-table.small-table thead th {
              background-color: #e0e0e0;
              font-weight: bold;
              text-align: left;

            }
        </style>
      </head>
      <body>
        <!-- Pulsanti -->
        <div class="controls">
          <button class="print-btn" onclick="window.print()" title="Salva PDF">💾</button>
          <button class="print-btn" onclick="window.close()" title="Chiudi">✖</button>
          <button class="print-btn" onclick="resetEditableFields()" title="Reset Campi">↺</button>
        </div>

        <!-- PAGINA 1 - Verticale -->
        <div class="page1">
          <div class="delimiter">
            <span>V.E.S. - Virtual Earth Suite</span>
            <span>Sviluppato dal Dott. Geol. Umberto Grechi</span>
          </div>

          <div class="header">
            <h1>V.E.S.</h1>
            <h2>Elaborato grafico prove penetrometriche</h2>
          </div>

          <table class="data-table">
            <tr><td>Committente</td><td><input type="text" id="committente" value=""></td></tr>
            <tr><td>Località</td><td><input type="text" id="localita" value=""></td></tr>
            <tr><td>Via</td><td><input type="text" id="via" value=""></td></tr>
            <tr><td>Tipo prova</td><td><div class="readonly">CPTU/E</div></td></tr>
            <tr><td>Data elaborazione</td><td><div class="readonly">${dateStr}</div></td></tr>
          </table>

          <div class="logo">
            <img src="${Logoblu}" alt="Logo">
          </div>
        </div>

        <!-- PAGINA 2 - Orizzontale parametri-->
        <div class="page2">
          <div class="content-wrapper" >
            <div class="title-left">
              <h2>Confronto parametri prove penetrometriche </h2>
              <hr>
            </div>
            <div class="chart-legend-wrapper"
                 style="display:flex; justify-content:center; align-items:center; gap:20px; margin-bottom:25px;">
                <div class="charts-container" id="chartsContainer1" >
                  <!-- I grafici verranno inseriti dinamicamente -->
                </div>
                <div id="sbt-zones-chart" style="width:120px; margin-right:70px;"></div>
                <div id="external-legend"></div>
            </div>
            <div class="didascalia">
              ${autLTVal === 0
                ? 'Fig1 - Plot profondità-variabile prove penetrometriche; A destra Indice SBT normalizzato (ICn)'
                : 'Fig1 - Plot profondità-variabile prove penetrometriche; A destra Indice SBT (IC)'}
            </div>
          </div>
        </div>

        <!-- PAGINA 3 - Orizzontale parametri-->
        <div class="page2">
          <div class="content-wrapper" >
            <div class="title-left">
              <h2>Confronto parametri prove penetrometriche </h2>
              <hr>
            </div>
            <div class="chart-legend-wrapper"
                 style="display:flex; justify-content:center; align-items:center; gap:20px; margin-bottom:25px;">
                <div class="charts-container" id="chartsContainer2" >
                  <!-- I grafici verranno inseriti dinamicamente -->
                </div>
                <div id="sbt-zones-chart-2" style="width:120px; margin-right:70px;"></div>
                <div id="external-legend-2"></div>
                </div>
                <div class="didascalia">
                  ${autLTVal === 0
                    ? 'Fig2 - Plot profondità-variabile prove penetrometriche; A destra Indice SBT normalizzato (ICn)'
                    : 'Fig2 - Plot profondità-variabile prove penetrometriche; A destra Indice SBT (IC)'}
                </div>
          </div>
        </div>

         <!-- PAGINA 4 - Orizzontale parametri-->
        <div class="page2">
          <div class="content-wrapper" >
            <div class="title-left">
              <h2>Confronto parametri prove penetrometriche </h2>
              <hr>
            </div>
            <div class="chart-legend-wrapper"
                 style="display:flex; justify-content:center; align-items:center; gap:20px; margin-bottom:25px;">
                <div class="charts-container" id="chartsContainer3" >
                  <!-- I grafici verranno inseriti dinamicamente -->
                </div>
                <div id="external-legend-3"></div>
                </div>
                <div class="didascalia">
                  Fig3 - Plot profondità-variabile prove penetrometriche
                </div>
          </div>
        </div>

        <!-- PAGINA 5 - Orizzontale parametri-->
        <div class="page2">
          <div class="content-wrapper" >
            <div class="title-left">
              <h2>Confronto parametri prove penetrometriche </h2>
              <hr>
            </div>
            <div class="chart-legend-wrapper"
                 style="display:flex; justify-content:center; align-items:center; gap:20px; margin-bottom:25px;">
                <div class="charts-container" id="chartsContainer4" >
                  <!-- I grafici verranno inseriti dinamicamente -->
                </div>
                <div id="external-legend-4"></div>
                </div>
                <div class="didascalia">
                  Fig4 - Plot profondità-variabile prove penetrometriche
                </div>
          </div>
        </div>


        <!-- PAGINA LEGGENDA - Verticale -->
        <div class="page1">
          <div class="delimiter">
            <span>V.E.S. - Virtual Earth Suite</span>
            <span>Sviluppato dal Dott. Geol. Umberto Grechi</span>
          </div>

          <div class="header">
            <h1 class="h1bis">Legenda parametri</h1>
          </div>
            <table class="data-table small-table">
              <thead>
                <tr>
                  <th>Variabile</th>
                  <th>Unità di misura</th>
                  <th>Descrizione</th>
                  <th>Tratto distintivo</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>qc</td>
                  <td>[MPa]</td>
                  <td>Resistenza alla punta</td>
                  <td>––––––</td>
                </tr>
                <tr>
                  <td>fs</td>
                  <td>[kPa]</td>
                  <td>Resistenza laterale</td>
                  <td>––––––</td>
                </tr>
                <tr>
                  <td>u</td>
                  <td>[kPa]</td>
                  <td>Pressione acqua interstiziale</td>
                  <td>––––––</td>
                </tr>
                <tr>
                  <td>Qt</td>
                  <td>[MPa]</td>
                  <td>Resistenza alla punta corretta</td>
                  <td>––––––</td>
                </tr>
                <tr>
                  <td>Qtn</td>
                  <td>[MPa]</td>
                  <td>Resistenza alla punta normalizzzata</td>
                  <td>––––––</td>
                </tr>
                <tr>
                  <td>Bq</td>
                  <td>[MPa]</td>
                  <td>Coefficente pressione normalizzato</td>
                  <td>––––––</td>
                </tr>
                 <tr>
                  <td>K</td>
                  <td>[m/s]</td>
                  <td>Permeabilità</td>
                  <td>––––––</td>
                </tr>
                <tr>
                  <td>Es</td>
                  <td>[MPa]</td>
                  <td>Modulo di young</td>
                  <td>––––––</td>
                </tr>
                <tr>
                  <td>G0</td>
                  <td>[MPa]</td>
                  <td>Modulo di taglio</td>
                  <td>––––––</td>
                </tr>
                <tr>
                  <td>K0</td>
                  <td>[-]</td>
                  <td>Coefficente di spinta a riposo</td>
                  <td>––––––</td>
                </tr>
                <tr>
                  <td>Cu</td>
                  <td>[kPa]</td>
                  <td>Coesione non drenata</td>
                  <td>––––––</td>
                </tr>
              </tbody>
              <tr>
                  <td>M</td>
                  <td>[MPa]</td>
                  <td>Modulo Edometrico</td>
                  <td>––––––</td>
              </tr>
              <tr>
                  <td>φ</td>
                  <td>[°]</td>
                  <td>Angolo di attrito</td>
                  <td>––––––</td>
              </tr>
              <tr>
                  <td>φ&prime;</td>
                  <td>[°]</td>
                  <td>Angolo di attrito efficace</td>
                  <td>––––––</td>
              </tr>
              <tr>
                  <td>IC</td>
                  <td>[-]</td>
                  <td>Indice di comportamento</td>
                  <td>––––––</td>
              </tr>
              <tr>
                  <td>ICn</td>
                  <td>[-]</td>
                  <td>Indice di comportamento normalizzato</td>
                  <td>––––––</td>
              </tr>
            </table>
          <div class="logo">
            <img src="${Logoblu}" alt="Logo">
          </div>
        </div>


        <script>
          var pages = document.querySelectorAll('.page1, .page2');
          pages.forEach(function(page, index) {
            var pageNumberDiv = document.createElement('div');
            pageNumberDiv.className = 'page-number';
            pageNumberDiv.style.position = 'absolute';
            pageNumberDiv.style.bottom = '5px';
            pageNumberDiv.style.left = '10px';
            pageNumberDiv.style.fontSize = '9px';
            pageNumberDiv.style.color = '#666';
            pageNumberDiv.innerText = (index + 1) + " / " + pages.length;
            page.appendChild(pageNumberDiv);
          });

          // Data di stampa
          var dataEl = document.getElementById('dataStampa');
          if (dataEl) {
            dataEl.innerText = "${dateStr} ${timeStr}";
          }
        </script>

        <!-- NESSUN ALTRO DIVISORE - così finisce qui -->

        <script>
          // Array di profondità per ogni CPT (supponendo tutti abbiano stessa lunghezza)
          const allData = ${allDataJson};
          const profSorted = allData.map(cpt => cpt.prof);
          // Variabili multi-prova
          const qcSorted    = allData.map(cpt => cpt.qc);
          const fsSorted    = allData.map(cpt => cpt.fs);
          const uSorted     = allData.map(cpt => cpt.u);
          const rfSorted    = allData.map(cpt => cpt.rf);
          const kSorted     = allData.map(cpt => cpt.k);
          const ocrSorted   = allData.map(cpt => cpt.ocr);
          const drSorted    = allData.map(cpt => cpt.dr);
          const resSorted   = allData.map(cpt => cpt.res);
          const g0Sorted    = allData.map(cpt => cpt.g0);
          const koSorted    = allData.map(cpt => cpt.ko);
          const cuSorted    = allData.map(cpt => cpt.cu);
          const curemSorted = allData.map(cpt => cpt.curem);
          const mSorted     = allData.map(cpt => cpt.m);
          const phiSorted   = allData.map(cpt => cpt.phi);
          const phipSorted  = allData.map(cpt => cpt.phip);
          const icnSorted   = allData.map(cpt => cpt.icn);
          const icSorted    = allData.map(cpt => cpt.ic);
          const qtSorted    = allData.map(cpt => cpt.qt);
          const qtnSorted    = allData.map(cpt => cpt.qtn);
          const bqSorted    = allData.map(cpt => cpt.bq);


          const pa = 0.1013252;
          const maxProf = ${maxProf};
          const minProf = ${minProf};
          const autLTVal = ${autLTVal};

          const COLOR_SCALE = [
              '#000000', // nero
              '#FF0000', // rosso
              '#0000FF', // blu
              '#008000', // verde
              '#FFA500', // arancione
              '#800080', // viola
              '#00FFFF', // ciano
              '#FFC0CB', // rosa
              '#A52A2A', // marrone
              '#FFFF00', // giallo
              '#800000', '#000080', '#008080', '#808000', '#FF00FF', '#00FF00', '#FF4500', '#DA70D6', '#7FFF00', '#1E90FF',
              '#B22222', '#FF1493', '#20B2AA', '#FF8C00', '#9932CC', '#ADFF2F', '#4682B4', '#FF6347', '#8B0000', '#00FA9A',
              '#9400D3', '#7B68EE', '#00CED1', '#FF69B4', '#228B22', '#FFD700', '#DC143C', '#40E0D0', '#FF7F50', '#6A5ACD',
              '#556B2F', '#00BFFF', '#FFB6C1', '#32CD32', '#8A2BE2', '#7FFFD4', '#FF4500', '#191970', '#00FF7F', '#FF1493'
            ];


          const charts1 = [
            {
              id: 'qcChart',
              key: 'qc',
              data: qcSorted,
              color: 'black',
              name: 'QC',
              xLabel: 'qc [MPa]'
            },
            {
              id: 'fsChart',
              key: 'fs',
              data: fsSorted,
              color: 'black',
              name: 'FS',
              xLabel: 'fs [kPa]'
            },
            {
              id: 'uChart',
              key: 'u',
              data: uSorted,
              color: 'black',
              name: 'U',
              xLabel: 'u [kPa]'
            },
          ];

          const charts2 = [
            {
              id: 'QtChart2',
              data: qtSorted,
              key: 'qt',
              color: 'black',
              name: 'Qt',
              xLabel: 'Qt [MPa]',
            },
            {
              id: 'QtnChart2',
              data: qtnSorted,
              key: 'qtn',
              color: 'black',
              name: 'Qtn',
              xLabel: 'Qtn',
            },
            {
              id: 'BqChart2',
              data: bqSorted,
              key: 'bq',
              color: 'black',
              name: 'Bq',
              xLabel: 'Bq',
            },
          ];

          const charts3 = [
            {
              id: 'cuChart3',
              data: cuSorted ,
              key: 'cu',
              color: 'black',
              name: 'cu',
              xLabel: 'cu [kPa]',
            },
            {
              id: 'phiChart3',
              data: phiSorted,
              key: 'phi',
              color: 'black',
              name: "φ",
              xLabel: "φ [°]"
            },
            {
              id: 'phipChart3',
              data: phipSorted,
              key: 'phip',
              color: 'black',
              name: "φ'",
              xLabel: "φ' [°]"
            },
            {
              id: 'k0Chart3',
              data: koSorted,
              key: 'ko',
              color: 'black',
              name: 'K0',
              xLabel: 'K0 [kPa]'
            },
          ];

          const charts4 = [
            {
              id: 'mChart4',
              data: mSorted ,
              key: 'm',
              color: 'black',
              name: 'M',
              xLabel: 'M [MPa]',
            },
            {
              id: 'resChart4',
              data: resSorted,
              key: 'res',
              color: 'black',
              name: "Es",
              xLabel: "Es [MPa]"
            },
            {
              id: 'g0Chart4',
              data: g0Sorted,
              key: 'g0',
              color: 'black',
              name: "G0",
              xLabel: "G0 [MPa]"
            },
            {
              id: 'kChart4',
              data: kSorted,
              key: 'k',
              color: 'black',
              name: 'K',
              xLabel: 'K [m/s]'
            },
          ];

          const CHART_WIDTH = 180;
          const CHART_HEIGHT = 570;

          // NUOVE dimensioni dedicate per SBT
          const LITO_CHART_WIDTH = 180;
          const LITO_CHART_HEIGHT = 570;

          window.resetEditableFields = function() {
            document.getElementById('committente').value = '';
            document.getElementById('localita').value = '';
            document.getElementById('via').value = '';
            document.getElementById('nome').value = '';
            localStorage.removeItem('cptReportData');
          };

          function loadSavedData() {
            const saved = localStorage.getItem('cptReportData');
            if (saved) {
              const data = JSON.parse(saved);
              document.getElementById('committente').value = data.committente || '';
              document.getElementById('localita').value = data.localita || '';
              document.getElementById('via').value = data.via || '';
              document.getElementById('nome').value = data.nome || '';
            }
          }

          function saveData() {
            const data = {
              committente: document.getElementById('committente').value,
              localita: document.getElementById('localita').value,
              via: document.getElementById('via').value,
              nome: document.getElementById('nome').value
            };
            localStorage.setItem('cptReportData', JSON.stringify(data));
          }

        function createCharts1() {
          const container = document.getElementById('chartsContainer1');
          if (!container) return;

          container.innerHTML = '';

          // Crea i contenitori per i grafici
          charts1.forEach(chart => {
            const chartDiv = document.createElement('div');
            chartDiv.className = 'chart-item';
            chartDiv.style.width = CHART_WIDTH + 'px';
            chartDiv.style.height = CHART_HEIGHT + 'px';

            const plotDiv = document.createElement('div');
            plotDiv.id = chart.id;
            plotDiv.className = 'plot-container';

            chartDiv.appendChild(plotDiv);
            container.appendChild(chartDiv);
          });

          // Crea i grafici
          charts1.forEach(chart => {
            const traces = allData.map((cpt, idx) => {
              const xData = cpt[chart.key]
                ? cpt[chart.key].map(v => (v === 0 || v === undefined || v === null) ? null : parseFloat(v))
                : [];

              // 3️⃣ Prendi il colore dalla scala esterna
              const color = COLOR_SCALE[idx % COLOR_SCALE.length];

              return {
                x: xData,
                y: cpt.prof,
                type: 'scatter',
                mode: 'lines',
                line: { color: color, width: 1.5 },
                name: cpt.name
              };
            });

            let allValues = [];
            allData.forEach(cpt => {
              if (cpt[chart.key]) {
                allValues = allValues.concat(cpt[chart.key].filter(v => v !== 0 && v !== undefined && v !== null && !isNaN(v)));
              }
            });

            const minVal = allValues.length ? Math.min(...allValues) * 0.9 : 0;
            const maxVal = allValues.length ? Math.max(...allValues) * 1.1 : 100;

            Plotly.newPlot(chart.id, traces, {
              width: CHART_WIDTH - 20,
              height: CHART_HEIGHT - 20,
              xaxis: {
                title: { text: chart.xLabel, font: { family: 'Roboto, sans-serif', size: 9 } },
                range: [minVal, maxVal],
                showgrid: true,
                gridcolor: '#888888',
                griddash: 'dash',
                tickfont: { family: 'Roboto, sans-serif', size: 8 },
                linecolor: 'black',
                zeroline: false,
                linewidth: 1,
                autorange: false
              },
              yaxis: {
                title: { text: 'Profondità [m]', font: { family: 'Roboto, sans-serif', size: 9 } },
                range: [maxProf, 0],
                showgrid: true,
                gridcolor: '#888888',
                griddash: 'dash',
                tickfont: { family: 'Roboto, sans-serif', size: 8 },
                linecolor: 'black',
                linewidth: 1,
                dtick: 1,
                autorange: false
              },
              margin: { t: 20, r: 20, l: 30, b: 30 },
              shapes: [
                  {
                    type: 'line',
                    xref: 'paper',
                    x0: 1,
                    x1: 1,
                    y0: 0,
                    y1: 1,
                    yref: 'paper',
                    line: { color: 'black', width: 1 }
                  }
                ],
              showlegend: false
            });
          });
        }

        function createCharts2() {
          const container2 = document.getElementById('chartsContainer2');
          if (!container2) return;

          container2.innerHTML = '';

          // Crea i contenitori per i grafici
          charts2.forEach(chart => {
            const chartDiv = document.createElement('div');
            chartDiv.className = 'chart-item';
            chartDiv.style.width = CHART_WIDTH + 'px';
            chartDiv.style.height = CHART_HEIGHT + 'px';

            const plotDiv = document.createElement('div');
            plotDiv.id = chart.id;
            plotDiv.className = 'plot-container';

            chartDiv.appendChild(plotDiv);
            container2.appendChild(chartDiv);
          });

          // Crea i grafici
          charts2.forEach(chart => {
            const traces = allData.map((cpt, idx) => {
              const xData = cpt[chart.key]
                ? cpt[chart.key].map(v => (v === 0 || v === undefined || v === null) ? null : parseFloat(v))
                : [];

              // 3️⃣ Prendi il colore dalla scala esterna
              const color = COLOR_SCALE[idx % COLOR_SCALE.length];

              return {
                x: xData,
                y: cpt.prof,
                type: 'scatter',
                mode: 'lines',
                line: { color: color, width: 1.5 },
                name: cpt.name
              };
            });

            let allValues = [];
            allData.forEach(cpt => {
              if (cpt[chart.key]) {
                allValues = allValues.concat(cpt[chart.key].filter(v => v !== 0 && v !== undefined && v !== null && !isNaN(v)));
              }
            });

            const minVal = allValues.length ? Math.min(...allValues) * 0.9 : 0;
            const maxVal = allValues.length ? Math.max(...allValues) * 1.1 : 100;

            Plotly.newPlot(chart.id, traces, {
              width: CHART_WIDTH - 20,
              height: CHART_HEIGHT - 20,
              xaxis: {
                title: { text: chart.xLabel, font: { family: 'Roboto, sans-serif', size: 9 } },
                range: [minVal, maxVal],
                showgrid: true,
                gridcolor: '#888888',
                griddash: 'dash',
                tickfont: { family: 'Roboto, sans-serif', size: 8 },
                linecolor: 'black',
                zeroline: false,
                linewidth: 1,
                autorange: false
              },
              yaxis: {
                title: { text: 'Profondità [m]', font: { family: 'Roboto, sans-serif', size: 9 } },
                range: [maxProf, 0],
                showgrid: true,
                gridcolor: '#888888',
                griddash: 'dash',
                tickfont: { family: 'Roboto, sans-serif', size: 8 },
                linecolor: 'black',
                linewidth: 1,
                dtick: 1,
                autorange: false
              },
              margin: { t: 20, r: 20, l: 30, b: 30 },
              shapes: [
                  {
                    type: 'line',
                    xref: 'paper',
                    x0: 1,
                    x1: 1,
                    y0: 0,
                    y1: 1,
                    yref: 'paper',
                    line: { color: 'black', width: 1 }
                  }
                ],
              showlegend: false
            });
          });
        }

        function createCharts3() {
          const container3 = document.getElementById('chartsContainer3');
          if (!container3) return;

          container3.innerHTML = '';

          // Crea i contenitori per i grafici
          charts3.forEach(chart => {
            const chartDiv = document.createElement('div');
            chartDiv.className = 'chart-item';
            chartDiv.style.width = CHART_WIDTH + 'px';
            chartDiv.style.height = CHART_HEIGHT + 'px';

            const plotDiv = document.createElement('div');
            plotDiv.id = chart.id;
            plotDiv.className = 'plot-container';

            chartDiv.appendChild(plotDiv);
            container3.appendChild(chartDiv);
          });

          // Crea i grafici
          charts3.forEach(chart => {
            const traces = allData.map((cpt, idx) => {
              const xData = cpt[chart.key]
                ? cpt[chart.key].map(v => (v === 0 || v === undefined || v === null) ? null : parseFloat(v))
                : [];

              // 3️⃣ Prendi il colore dalla scala esterna
              const color = COLOR_SCALE[idx % COLOR_SCALE.length];

              return {
                x: xData,
                y: cpt.prof,
                type: 'scatter',
                mode: 'lines',
                line: { color: color, width: 1.5 },
                name: cpt.name
              };
            });

            let allValues = [];
            allData.forEach(cpt => {
              if (cpt[chart.key]) {
                allValues = allValues.concat(cpt[chart.key].filter(v => v !== 0 && v !== undefined && v !== null && !isNaN(v)));
              }
            });

            const minVal = allValues.length ? Math.min(...allValues) * 0.9 : 0;
            const maxVal = allValues.length ? Math.max(...allValues) * 1.1 : 100;

            Plotly.newPlot(chart.id, traces, {
              width: CHART_WIDTH - 20,
              height: CHART_HEIGHT - 20,
              xaxis: {
                title: { text: chart.xLabel, font: { family: 'Roboto, sans-serif', size: 9 } },
                range: [minVal, maxVal],
                showgrid: true,
                gridcolor: '#888888',
                griddash: 'dash',
                tickfont: { family: 'Roboto, sans-serif', size: 8 },
                linecolor: 'black',
                zeroline: false,
                linewidth: 1,
                autorange: false
              },
              yaxis: {
                title: { text: 'Profondità [m]', font: { family: 'Roboto, sans-serif', size: 9 } },
                range: [maxProf, 0],
                showgrid: true,
                gridcolor: '#888888',
                griddash: 'dash',
                tickfont: { family: 'Roboto, sans-serif', size: 8 },
                linecolor: 'black',
                linewidth: 1,
                dtick: 1,
                autorange: false
              },
              margin: { t: 20, r: 20, l: 30, b: 30 },
              shapes: [
                  {
                    type: 'line',
                    xref: 'paper',
                    x0: 1,
                    x1: 1,
                    y0: 0,
                    y1: 1,
                    yref: 'paper',
                    line: { color: 'black', width: 1 }
                  }
                ],
              showlegend: false
            });
          });
        }

        function createCharts4() {
          const container4 = document.getElementById('chartsContainer4');
          if (!container4) return;

          container4.innerHTML = '';

          // 🔹 CREA CONTENITORI
          charts4.forEach(chart => {
            const chartDiv = document.createElement('div');
            chartDiv.className = 'chart-item';
            chartDiv.style.width = CHART_WIDTH + 'px';
            chartDiv.style.height = CHART_HEIGHT + 'px';

            const plotDiv = document.createElement('div');
            plotDiv.id = chart.id;
            plotDiv.className = 'plot-container';

            chartDiv.appendChild(plotDiv);
            container4.appendChild(chartDiv);
          });

          // 🔹 CREA GRAFICI
          charts4.forEach(chart => {

            // 🔸 TRACCE MULTI-CPT (come createCharts1)
            const traces = allData.map((cpt, idx) => {

              const xData = cpt[chart.key]
                  ? cpt[chart.key].map(v => {
                      const n = Number(v);

                      // 🔥 MASCHERA TUTTO QUELLO CHE NON VUOI PLOTTARE
                      if (isNaN(n) || n === 0) return null;

                      // 🔥 in log serve anche > 0
                      if (chart.id === 'kChart4' && n <= 0) return null;

                      return n;
                    })
                  : [];

              const color = COLOR_SCALE[idx % COLOR_SCALE.length];

              return {
                x: xData,
                y: cpt.prof,
                type: 'scatter',
                mode: 'lines',
                line: { color: color, width: 1.5 },
                name: cpt.name
              };
            });

            // 🔸 COSTRUISCO allData come in createCharts2
            let allValues = [];

            allData.forEach(cpt => {
              if (cpt[chart.key]) {
                allValues = allValues.concat(
                  cpt[chart.key]
                    .map(v => Number(v))
                    .filter(v => !isNaN(v) && v !== 0)
                );
              }
            });



            // 🔸 FORMAT ASSE X (UGUALE A createCharts2)
            let xAxisFormat = {};

                if (chart.id === 'kChart4') {

                  const validLogValues = allValues.filter(v => v > 0);

                  if (!validLogValues.length) {
                    console.warn('Nessun valore valido per log:', chart.key);
                    return;
                  }

                  const minVal = Math.min(...validLogValues);
                  const maxVal = Math.max(...validLogValues);

                  const minBuffered = minVal * 0.9;
                  const maxBuffered = maxVal * 1.1;

                  xAxisFormat = {
                    title: { text: chart.xLabel, font: { family: 'Roboto, sans-serif', size: 9 } },
                    type: 'log',
                    range: [
                      Math.log10(minBuffered),
                      Math.log10(maxBuffered)
                    ],
                    showgrid: true,
                    gridcolor: '#888888',
                    griddash: 'dash',
                    tickfont: { family: 'Roboto, sans-serif', size: 8 },
                    linecolor: 'black',
                    linewidth: 1,
                    exponentformat: 'power',
                    autorange: false
                  };

                } else {

                  const minVal = allValues.length ? Math.min(...allValues) * 0.9 : 0;
                  const maxVal = allValues.length ? Math.max(...allValues) * 1.1 : 100;

                  xAxisFormat = {
                    title: { text: chart.xLabel, font: { family: 'Roboto, sans-serif', size: 9 } },
                    range: [minVal, maxVal],
                    showgrid: true,
                    gridcolor: '#888888',
                    griddash: 'dash',
                    tickfont: { family: 'Roboto, sans-serif', size: 8 },
                    linecolor: 'black',
                    linewidth: 1,
                    autorange: false
                  };
                }

            // 🔸 LINEA DI FINE GRAFICO (come createCharts2)
            const maxLine = allValues.length ? Math.max(...allValues) * 1.1 : 0;

            // 🔸 PLOT
            Plotly.newPlot(chart.id, traces, {
              width: CHART_WIDTH - 20,
              height: CHART_HEIGHT - 20,
              xaxis: xAxisFormat,
              yaxis: {
                title: { text: 'Profondità [m]', font: { family: 'Roboto, sans-serif', size: 9 } },
                range: [maxProf, 0],
                showgrid: true,
                gridcolor: '#888888',
                griddash: 'dash',
                tickfont: { family: 'Roboto, sans-serif', size: 8 },
                linecolor: 'black',
                linewidth: 1,
                dtick: 1,
                autorange: false
              },
              margin: { t: 20, r: 20, l: 30, b: 30 },
              shapes: [
                {
                  type: 'line',
                  x0: maxLine,
                  x1: maxLine,
                  y0: 0,
                  y1: maxProf,
                  line: { color: 'black', width: 1 }
                }
              ],
              showlegend: false
            });

          });
        }


        function createSBTindex(containerId) {
            const container = document.getElementById(containerId);
            if (!container) return;
            container.innerHTML = '';

            const dict_plt = {
                2: 'saddlebrown',
                3: 'darkolivegreen',
                4: 'forestgreen',
                5: 'goldenrod',
                6: 'darkgoldenrod',
                7: 'gold'
            };

            const zones = [
                { id: 7, x0: 1,    x1: 1.31 },
                { id: 6, x0: 1.31, x1: 2.05 },
                { id: 5, x0: 2.05, x1: 2.6 },
                { id: 4, x0: 2.6,  x1: 2.95 },
                { id: 3, x0: 2.95, x1: 3.6 },
                { id: 2, x0: 3.6,  x1: 4 }
            ];

            const shapes = zones.map(z => ({
                type: "rect",
                x0: z.x0,
                x1: z.x1,
                y0: 0,
                y1: maxProf,
                line: { width: 0 },
                fillcolor: dict_plt[z.id],
                opacity: 0.9,
                layer: 'below'
            }));

            // Determina tipo (IC / ICn)
            const isICN = (typeof autLTVal !== 'undefined' && autLTVal === 0);
            const xAxisTitle = isICN ? 'ICn' : 'IC';
            const key = isICN ? 'icn' : 'ic';

            // 🔥 TRACE DINAMICI MULTI-CPT (come createCharts1)
            const traces = allData.map((cpt, idx) => {

                const rawData = cpt[key];

                const xData = rawData
                    ? rawData.map(v => (v === 0 || v == null) ? null : parseFloat(v))
                    : [];

                const color = COLOR_SCALE[idx % COLOR_SCALE.length];

                return {
                    x: xData,
                    y: cpt.prof,
                    mode: 'lines',
                    line: { color: color, width: 1.5 },
                    name: cpt.name
                };
            });

            const layout = {
                width: LITO_CHART_WIDTH -20,
                height: LITO_CHART_HEIGHT -20,
                xaxis: {
                    title: {
                        text: xAxisTitle,
                        font: { family: 'Roboto, sans-serif', size: 10 },
                        standoff: 40
                    },
                    range: [1, 4],
                    showgrid: false,
                    tickfont: { family: 'Roboto, sans-serif', size: 8 }
                },
                yaxis: {
                    title: {
                        text: 'Profondità [m]',
                        font: { family: 'Roboto, sans-serif', size: 10 }
                    },
                    range: [maxProf, 0],
                    autorange: false,
                    showgrid: false,
                    linewidth: 1,
                    dtick: 1,
                    tickfont: { family: 'Roboto, sans-serif', size: 8 }
                },
                shapes: shapes,
                plot_bgcolor: "white",
                margin: { t: 20, l: 30, r: 20, b: 30 },
                showlegend: false // puoi mettere false se non vuoi legenda
            };

            Plotly.newPlot(containerId, traces, layout, {
                responsive: true,
                displayModeBar: false
            });
        }

        function createExternalLegend(containerId) {
            const container = document.getElementById(containerId);
            if (!container) return;

            container.innerHTML = '';

            const title = document.createElement('div');
            title.textContent = 'Legenda';
            title.style.fontWeight = 'bold';
            title.style.fontSize = '12px';
            title.style.marginBottom = '8px';
            title.style.fontFamily = 'Roboto, sans-serif';
            container.appendChild(title);

            allData.forEach((cpt, idx) => {
                const item = document.createElement('div');
                item.style.display = 'flex';
                item.style.alignItems = 'center';
                item.style.marginBottom = '6px';
                item.style.fontSize = '10px';
                item.style.fontFamily = 'Roboto, sans-serif';

                // 🔥 LINEA invece del quadrato
                const line = document.createElement('div');
                line.style.width = '20px';
                line.style.height = '0';
                line.style.borderTop = '2px solid ' + COLOR_SCALE[idx % COLOR_SCALE.length];
                line.style.marginRight = '6px';

                const label = document.createElement('span');
                label.textContent = cpt.name;

                item.appendChild(line);
                item.appendChild(label);
                container.appendChild(item);
            });
        }

          // Inizializzazione
          loadSavedData();
          createCharts1();
          createCharts2();
          createCharts3();
          createCharts4();
          createExternalLegend('external-legend');
          createExternalLegend('external-legend-2');
          createExternalLegend('external-legend-3');
          createExternalLegend('external-legend-4');

          createSBTindex('sbt-zones-chart');
          createSBTindex('sbt-zones-chart-2');
          createSBTindex('sbt-zones-chart-3');
          createSBTindex('sbt-zones-chart-4');

          document.getElementById('committente').addEventListener('input', saveData);
          document.getElementById('localita').addEventListener('input', saveData);
          document.getElementById('via').addEventListener('input', saveData);
          document.getElementById('nome').addEventListener('input', saveData);

        </script>
      </body>
    </html>
  `);

  reportWindow.document.close();
};